// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1_NF3","cls2":"ResearchInterestTags-cls2_obO ResearchInterestTags-cls1_NF3"};